var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",class:{
    'slo-editable-text': true,
    'focus-within': _vm.focusWithin,
    placeholder: !_vm.value,
  }},[_c('input',_vm._b({ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"keydown":function($event){return _vm.handleKeydown($event)},"input":function($event){$event.stopPropagation();return _vm.handleInput.apply(null, arguments)},"focus":function($event){_vm.focusWithin = true},"blur":function($event){return _vm.handleBlur($event)}}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.value || _vm.placeholder))])])
}
var staticRenderFns = []

export { render, staticRenderFns }